<editor
  id="tinymce"
  (onInit)="handleOnInit()"
  [init]="{
    base_url: '/tinymce',
    suffix: '.min',
  }"
  (onKeyPress)="emitChange($event)"
></editor>
